import Container from 'typedi'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import RegistrationLinkService from '../services/registration-link.service'

@Module({
  namespaced: true
})
export default class RegistrationLinkStore extends VuexModule {
  registrationLinks: any[] = []

  @Mutation
  SET_REGISTRATION_LINKS (payload: any) {
    this.registrationLinks = payload
  }

  @Action({ rawError: true })
  async getRegistrationLinks (payload: any) {
    const { event_uuid } = payload
    const response = await Container.get(RegistrationLinkService).getRegistrationLinks(event_uuid)
    this.context.commit('SET_REGISTRATION_LINKS', response.data)
    return response.data
  }

  @Action({ rawError: true })
  async createRegistrationLink (payload: any) {
    const { data, event_uuid } = payload
    const response = await Container.get(RegistrationLinkService).addRegistrationLink(data, event_uuid)
    this.context.dispatch('getRegistrationLinks', payload)
    return response.data
  }

  @Action({ rawError: true })
  async editRegistrationLink (payload: any) {
    const { data, event_uuid, registration_link_uuid } = payload
    const response = await Container.get(RegistrationLinkService).updateRegistrationLink(data, event_uuid, registration_link_uuid)
    this.context.dispatch('getRegistrationLinks', payload)
    return response.data
  }

  @Action({ rawError: true })
  async deleteRegistrationLink (payload: any) {
    const { event_uuid, registration_link_uuid } = payload
    const response: any = await Container.get(RegistrationLinkService).deleteRegistrationLink(event_uuid, registration_link_uuid)
    this.context.dispatch('getRegistrationLinks', payload)
    return response
  }
}
